module.exports = __webpack_public_path__ + "img/smb-funding-2.877c2fff.png";